// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

import "@hotwired/turbo-rails"
import "@fontsource-variable/inter"
import "@fontsource-variable/montserrat"
import "@fontsource-variable/antonio"
import "animate.css"
import "protos-stimulus"

import "../controllers/application"

document.addEventListener("turbo:frame-render", () => {
  const scrollToElement = document.getElementById("scroll-to")

  if (scrollToElement) {
    const targetScrollPosition =
      scrollToElement.offsetTop - scrollToElement.dataset.scrollOffset

    window.scrollTo({
      top: targetScrollPosition,
      behavior: "smooth",
    })
  }
})

// Preserve scroll positions and drawer state when rendering a turbo frame.
// Elements opt in to scroll preservation via the scroll="preserve" attribute.
window.addEventListener("turbo:before-frame-render", (event) => {
  const frame = event.target

  const preserveScroll =
    frame.getAttribute("scroll") === "preserve" &&
    event.detail.newFrame.getAttribute("scroll") === "preserve"

  const drawerToggles = [...frame.querySelectorAll("input.drawer-toggle")]
  if (!preserveScroll && drawerToggles.length === 0) return

  const checkedStates = drawerToggles.map((toggle) => toggle.checked)
  const scrollPositions = [
    ...frame.querySelectorAll('[scroll="preserve"]'),
  ].map((element) => element.scrollTop)
  const firstElementScrollPosition = frame.firstElementChild?.scrollTop

  const originalRender = event.detail.render
  event.detail.render = async (currentElement, newElement) => {
    newElement
      .querySelectorAll("input.drawer-toggle")
      .forEach((toggle, index) => {
        toggle.checked = checkedStates[index] ?? false
      })

    await originalRender(currentElement, newElement)

    if (!preserveScroll) return

    if (firstElementScrollPosition) {
      frame.firstElementChild.scrollTop = firstElementScrollPosition
    }

    frame
      .querySelectorAll('[scroll="preserve"]')
      .forEach((element, index) => {
        if (scrollPositions[index]) {
          element.scrollTop = scrollPositions[index]
        }
      })
  }
})

// Handles issue where visiting a page with data-turbo-action="advance" will
// prevent page scroll from resetting when navigating to a new page.
// https://github.com/hotwired/turbo/issues/1526
// The filter sidebar relies on preserving its scroll position, so visits
// originating from it are excluded from this fix.
document.addEventListener("turbo:before-visit", (event) => {
  const isFilterSidebar = event.detail.originalEvent?.target?.closest?.(
    "form#sidebar"
  )

  if (!isFilterSidebar) {
    Turbo.navigator.view.forceReloaded = false
  }
})
